<ngb-toast
  [class]="toast.classname"
  [class.progress-toast]="toast.progress || toast.indeterminateProgress"
  [autohide]="!toast.noDelay"
  [delay]="toast.delay || 7000"
  (hidden)="remove.emit(toast)"
>
  @if (!toast.progress && !toast.indeterminateProgress) {
    @if (isComponent(toast)) {
      <ng-template #toastContainer></ng-template>
    } @else {
      @if (isTemplate(toast)) {
        <ng-template
          [ngTemplateOutlet]="toast.textOrTpl"
          [ngTemplateOutletContext]="{ toast: toast }"
        >
        </ng-template>
      } @else {
        <div class="toast-icon">
          @if (isV4Design && isWarningToast(toast)) {
            <i class="toast-icon fa-light fa-circle-exclamation"></i>
          } @else if (newDesign) {
            <i
              class="toast-icon hgi hgi-stroke"
              [class]="getToastIconNewDesign(toast)"
            ></i>
          } @else {
            <i
              class="material-icons"
              aria-hidden="true"
              >{{ getToastIcon(toast) }}</i
            >
          }
        </div>

        <div
          class="toast-text"
          [innerHTML]="toast.textOrTpl"
        ></div>

        <div class="toast-close-button">
          <button
            type="button"
            class="btn btn-link close-btn"
            (click)="remove.emit(toast)"
          >
            @if (newDesign) {
              <i class="hgi hgi-stroke hgi-cancel-01"></i>
            } @else {
              <i
                class="material-icons"
                aria-hidden="true"
                >close</i
              >
            }
          </button>
        </div>
      }
    }
  }

  @if (toast.progress) {
    <ng-container *ngTemplateOutlet="progressToast"></ng-container>
  }

  @if (toast.indeterminateProgress) {
    <ng-container *ngTemplateOutlet="indeterminateProgressToast"></ng-container>
  }

  <ng-template #progressToast>
    @if (toast.progress | async; as progress) {
      <div class="toast-header-row">
        <div class="toast-icon">
          @if (isV4Design && isWarningToast(toast)) {
            <i class="fa-light fa-circle-exclamation"></i>
          } @else if (newDesign) {
            <i
              class="hgi hgi-stroke"
              [class]="getToastIconNewDesign(toast)"
            ></i>
          } @else {
            <i class="material-icons">{{ getToastIcon(toast) }}</i>
          }
        </div>

        <div
          class="toast-text"
          [innerHTML]="toast.textOrTpl"
        ></div>

        <div class="toast-close-button">
          <button
            type="button"
            class="btn btn-link close-btn"
            (click)="remove.emit(toast)"
          >
            @if (newDesign) {
              <i class="hgi hgi-stroke hgi-cancel-01"></i>
            } @else {
              <i
                class="material-icons"
                aria-hidden="true"
                >close</i
              >
            }
          </button>
        </div>
      </div>
      <div class="progress-container">
        <div class="progress"><div [style.width.%]="getProgressCurrent(progress)"></div></div>
        <span class="percents"> {{ getProgressCurrent(progress) }} %</span>
      </div>
    }
  </ng-template>

  <ng-template #indeterminateProgressToast>
    <div class="toast-header-row">
      <div class="toast-icon">
        @if (isV4Design && isWarningToast(toast)) {
          <i class="toast-icon fa-light fa-circle-exclamation"></i>
        } @else if (newDesign) {
          <i
            class="toast-icon hgi hgi-stroke"
            [class]="getToastIconNewDesign(toast)"
          ></i>
        } @else {
          <i
            class="material-icons"
            aria-hidden="true"
            >{{ getToastIcon(toast) }}</i
          >
        }
      </div>

      <div
        class="toast-text indeterminate"
        [innerHTML]="toast.textOrTpl"
      ></div>

      <div class="toast-close-button">
        <button
          type="button"
          class="btn btn-link close-btn"
          (click)="remove.emit(toast)"
        >
          @if (newDesign) {
            <i class="hgi hgi-stroke hgi-cancel-01"></i>
          } @else {
            <i
              class="material-icons"
              aria-hidden="true"
              >close</i
            >
          }
        </button>
      </div>
    </div>
    <div class="progress-container">
      <div class="progress indeterminate">
        <div class="indeterminate-bar-value"></div>
      </div>
    </div>
  </ng-template>
</ngb-toast>
